import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesDeliveryProcedureDiagram} from './citizens-services-delivery-procedure-diagram.model';
import * as CitizensServicesDeliveryProcedureDiagramActions
  from './citizens-services-delivery-procedure-diagram.actions';

export const citizensServicesDeliveryProcedureDiagramsFeatureKey = 'citizensServicesDeliveryProcedureDiagrams';

export interface State extends EntityState<CitizensServicesDeliveryProcedureDiagram> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesDeliveryProcedureDiagram> = createEntityAdapter<CitizensServicesDeliveryProcedureDiagram>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesDeliveryProcedureDiagramActions.addCitizensServicesDeliveryProcedureDiagram,
    (state, action) => adapter.addOne(action.citizensServicesDeliveryProcedureDiagram, state)
  ),
  on(CitizensServicesDeliveryProcedureDiagramActions.upsertCitizensServicesDeliveryProcedureDiagram,
    (state, action) => adapter.upsertOne(action.citizensServicesDeliveryProcedureDiagram, state)
  ),
  on(CitizensServicesDeliveryProcedureDiagramActions.addCitizensServicesDeliveryProcedureDiagrams,
    (state, action) => adapter.addMany(action.citizensServicesDeliveryProcedureDiagrams, state)
  ),
  on(CitizensServicesDeliveryProcedureDiagramActions.upsertCitizensServicesDeliveryProcedureDiagrams,
    (state, action) => adapter.upsertMany(action.citizensServicesDeliveryProcedureDiagrams, state)
  ),
  on(CitizensServicesDeliveryProcedureDiagramActions.updateCitizensServicesDeliveryProcedureDiagram,
    (state, action) => adapter.updateOne(action.citizensServicesDeliveryProcedureDiagram, state)
  ),
  on(CitizensServicesDeliveryProcedureDiagramActions.updateCitizensServicesDeliveryProcedureDiagrams,
    (state, action) => adapter.updateMany(action.citizensServicesDeliveryProcedureDiagrams, state)
  ),
  on(CitizensServicesDeliveryProcedureDiagramActions.deleteCitizensServicesDeliveryProcedureDiagram,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesDeliveryProcedureDiagramActions.deleteCitizensServicesDeliveryProcedureDiagrams,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesDeliveryProcedureDiagramActions.loadCitizensServicesDeliveryProcedureDiagrams,
    (state, action) => adapter.setAll(action.citizensServicesDeliveryProcedureDiagrams, state)
  ),
  on(CitizensServicesDeliveryProcedureDiagramActions.clearCitizensServicesDeliveryProcedureDiagrams,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
